import dayjs from 'dayjs';

const dateFormat = (date: string) => {
	const dateParts = date && date.split(' ');
	const utcDate = dateParts && dayjs(dateParts[0]);
	const formattedDate = utcDate && utcDate.format('DD MMM, YYYY');

	return formattedDate || '';
};

export const formatOnlyTime = (time: any, date?: any, format?: any) => {
	if (!time) return '';
	const d = date || dayjs(date).isValid() ? dayjs(date) : dayjs();
	const [h, m, s] = time.split(':').map(Number);

	const fTime = d.hour(h).minute(m).second(s);

	return format ? fTime.format(format) : fTime;
};

export const formatDate = (date?: any, format?: any) => {
	if (!date) return '';

	const d = dayjs.isDayjs(date) ? date : dayjs(date);

	if (!d.isValid()) return '';

	return format ? d.format(format) : d.format('DD-MM-YYYY');
};

export const formatDataTime = (date: string) => {
	if (!date) return ''; 
  
	// Parse the date without converting it to a timezone
	const parsedDate = dayjs(date);
  
	if (!parsedDate.isValid()) return ''; 
  
	return parsedDate.format('DD MMM, YYYY • HH:mm');
  }
  
export { dateFormat };
export default dateFormat;

export const getMinutesFromTime = (timeString) => {
	if(!timeString) return 0
    const time = dayjs(timeString, "HH:mm:ss");
    return time.hour() * 60 + time.minute(); // Convert hours to minutes and add minutes
};

export const getTimeFromMinutes = (minutes) => {
	if(!minutes)return undefined
	return dayjs().startOf("day").add(Number(minutes), "minutes").format("HH:mm:ss");
};

export const UTCDateFormat = (date: string,format) => {
	if(!date) return null
	const dateObj = dayjs.utc(date.replace(' ', 'T').slice(0, 26)).toISOString()
	return formatDate(dateObj, format);
};

export const formatUtcDate = (date?: any, format?: any) => {
	if (!date) return '';

	const d = dayjs.utc(date);

	if (!d.isValid()) return '';

	return format ? d.format(format) : d.format('DD-MM-YYYY');
};